import superagent from "superagent";
import { encrypt, decrypt } from "@/utils/des";
import { host, tokenPrefix } from "./host";

const addAdmin = ({ account, password }) => {
  return new Promise((resolve, reject) => {
    superagent
      .post(`${host}/v1/admin/create`)
      .set("token", encrypt(`${tokenPrefix}.admin`))
      .send({
        account,
        password,
      })
      .then(
        (res) => {
          if (res.body.err === 0) {
            resolve(res.body.data);
          }
        },
        (err) => {
          reject(err);
        },
      );
  });
};

const updateAdmin = ({ account, password }) => {
  return new Promise((resolve, reject) => {
    const admin_id = "admin-1701426797";
    superagent
      .put(`${host}/v1/admin/${admin_id}/update`)
      .set("token", encrypt(`${admin_id}.admin`))
      .send({
        account: account,
        password: password,
        admin_id,
      })
      .then(
        (res) => {
          if (res.body.err === 0) {
            resolve(res.body.data);
          }
        },
        (err) => {
          reject(err);
        },
      );
  });
};

const getAdmin = ({ account, password }) => {
  return new Promise((resolve, reject) => {
    superagent
      .post(`${host}/v1/admin/list/1/1000`)
      .set("token", encrypt(`${tokenPrefix}.admin`))
      .send({
        account,
        password,
      })
      .then(
        (res) => {
          if (res.body.err === 0) {
            resolve(res.body.data[0]);
          }
        },
        (err) => {
          reject(err);
        },
      );
  });
};

const getAllAdmin = () => {
  return new Promise((resolve, reject) => {
    superagent
      .post(`${host}/v1/admin/list/1/1000`)
      .set("token", encrypt(`${tokenPrefix}.admin`))
      .send({})
      .then(
        (res) => {
          if (res.body.err === 0) {
            resolve(res.body.data);
          }
        },
        (err) => {
          reject(err);
        },
      );
  });
};

export { addAdmin, updateAdmin, getAdmin, getAllAdmin };
